import { render, staticRenderFns } from "./boutique.vue?vue&type=template&id=444f4312&scoped=true&"
import script from "./boutique.vue?vue&type=script&lang=js&"
export * from "./boutique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444f4312",
  null
  
)

export default component.exports